import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-invvehiculo',
  templateUrl: './invvehiculo.component.html',
  styleUrls: ['./invvehiculo.component.css']
})
export class InvvehiculoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
